import CreditCard from './CreditCard';

export default CreditCard;
